<template>
	<el-card shadow="never" class="aui-card--fill">
		<el-row style="background-color: #F3F4F4;">
			<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;"
					src="../../../assets/img/usericon.png" />企业用户详情信息
			</el-col>
			<el-col :xs="24" :md="18">
				<el-form style="text-align: right;">
					<el-form-item>
            <el-button v-no-more-click  class="addBtn" style="left: 1000px;"
							v-if="$hasPermission('user:qyyhuser:save') && dataForm.status == 2" type="primary"
							@click="editHandle()">{{isEditBtn ? '修改' : '提交'}}</el-button>
						<el-button v-no-more-click  class="addBtn" style="left: 1000px;"
							v-if="$hasPermission('user:qyyhuser:save') && dataForm.status == 0" type="primary"
							@click="dataFormSubmitHandle(0)">保存</el-button>
						<el-button v-no-more-click  class="addBtn" style="left: 1115px;"
							v-if="$hasPermission('user:qyyhuser:submit') && dataForm.status == 0" type="info"
							@click="dataFormSubmitHandle(1)">提交</el-button>
						<el-button v-no-more-click  class="addBtn" style="left: 1240px;"
							v-if="$hasPermission('user:qyyhuser:checked') && dataForm.status == 1" type="primary"
							@click="dataFormStatusHandle('1',dataForm.userId)" >审核通过</el-button>
						<el-button v-no-more-click  class="addBtn" style="left: 1390px;"
							v-if="$hasPermission('user:qyyhuser:checked') && dataForm.status == 1" type="danger"
							@click="dataFormStatusHandle('0',dataForm.userId)">驳回</el-button>
						<el-button class="addBtn" style="left: 1515px;" type="info" @click="getInfo()">刷新</el-button>
						<el-button class="addBtn" style="left: 1515px;" type="info" @click="$router.go(-1)">返回
						</el-button>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>

		<el-form label-width="120px" style="border-bottom: 1px solid #D7D7D7;padding-top: 20px;" :model="dataForm"
			:rules="dataRule" ref="dataForm">
			<el-row>
				<el-col :sm="24" :lg="8">
					<el-row>
						<div
								style="font-size: 12px;font-weight: bold;color: #343434;line-height: 48px;width: 120px;text-align: right;">
							企业营业执照照片</div>
						<div>
							<el-form-item prop="licensePath" style="display: inline-block;">
								<el-upload ref="upload" :action="url"  class="avatar-uploader" :multiple="multiple"
										   :before-upload="beforeUploadHandle" :on-success="licensePathsuccessHandle"
										   :auto-upload="true" :show-file-list="false"
										   :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false">
									<el-image v-if="dataForm.licensePath"
										 :src="dataForm.licensePath" class="avatar" :preview-src-list="[dataForm.licensePath]"></el-image>
									<i v-else
									   :style="{backgroundImage:'url('+require('../../../assets/img/yingye.png')+')',backgroundSize:'100% 100%',backgroundRepeat:'no-repeat',color:'#315DD1'}"
									   :class="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn ) ? 'el-icon-circle-plus avatar-uploader-icon el-noicon' : 'el-icon-circle-plus avatar-uploader-icon'"></i>
									<div slot="tip" class="el-upload__tip" style="line-height: 20px;">
										{{tip}}
                    <!-- <span class="delUploadPic el-icon-view" v-if="dataForm.licensePath" @click="handlePictureCardPreview(dataForm.licensePath)" style="color:#188eee;margin-left:10px;"></span> -->
                    <span class="delUploadPic el-icon-delete" v-if="dataForm.licensePath && ((dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?false:true)" @click="delPicUrl('licensePath')"></span>
                  </div>
								</el-upload>

							</el-form-item>
						</div>
					</el-row>
				</el-col>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
				<el-col :sm="24" :lg="16">
					<el-row>
						<div
								style="font-size: 12px;font-weight: bold;color: #343434;line-height: 48px;width: 120px;text-align: right;">
							法人身份证<font color='red'>(非必填)</font>
						</div>
						<div>
							<el-form-item prop="idcardFacePath" style="display: inline-block;">
								<el-upload ref="upload" :action="url" class="avatar-uploader"
										   :multiple="multiple" :before-upload="beforeUploadHandle"
										   :on-success="beforesuccessHandle" :auto-upload="true"
										   :show-file-list="false" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false">
									<el-image v-if="dataForm.idcardFacePath" :src="dataForm.idcardFacePath" class="avatar" :preview-src-list="[dataForm.idcardFacePath]"></el-image>
									<i v-else
									   :style="{backgroundImage:'url('+require('../../../assets/img/cardFront.png')+')',backgroundSize:'100% 100%',backgroundRepeat:'no-repeat',color:'#315DD1'}"
                     :class="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn ) ? 'el-icon-circle-plus avatar-uploader-icon el-noicon' : 'el-icon-circle-plus avatar-uploader-icon'"></i>
									<div slot="tip" class="el-upload__tip" style="line-height: 20px;">
										{{tip1}}
                    <span class="delUploadPic el-icon-view" v-if="dataForm.idcardFacePath" @click="handlePictureCardPreview(dataForm.idcardFacePath)" style="color:#188eee;margin-left:10px;"></span>
                    <span class="delUploadPic el-icon-delete" v-if="dataForm.idcardFacePath && ((dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?false:true)" @click="delPicUrl('idcardFacePath')"></span>
                  </div>
								</el-upload>
							</el-form-item>
							<el-form-item prop="idcardBackPath" style="display: inline-block;">
								<el-upload ref="upload" :action="url" class="avatar-uploader"
										   :multiple="multiple" :before-upload="beforeUploadHandle"
										   :on-success="backsuccessHandle" :auto-upload="true" :show-file-list="false"
										   :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false">
									<el-image v-if="dataForm.idcardBackPath" :preview-src-list="[dataForm.idcardBackPath]"
										 :src="dataForm.idcardBackPath" class="avatar"></el-image>
									<i v-else
									   :style="{backgroundImage:'url('+require('../../../assets/img/cardBack.png')+')',backgroundSize:'100% 100%',backgroundRepeat:'no-repeat',color:'#315DD1'}"
                     :class="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn ) ? 'el-icon-circle-plus avatar-uploader-icon el-noicon' : 'el-icon-circle-plus avatar-uploader-icon'"></i>
									<div slot="tip" class="el-upload__tip" style="line-height: 20px;">
										{{tip2}}
                    <span class="delUploadPic el-icon-view" v-if="dataForm.idcardBackPath" @click="handlePictureCardPreview(dataForm.idcardBackPath)" style="color:#188eee;margin-left:10px;"></span>
                    <span class="delUploadPic el-icon-delete" v-if="dataForm.idcardBackPath && ((dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?false:true)" @click="delPicUrl('idcardBackPath')"></span>
                  </div>
								</el-upload>
							</el-form-item>
						</div>
					</el-row>

				</el-col>
			</el-row>
			<el-row>
				<el-col :sm="12" :lg="12">
					<el-form-item label="经营范围" prop="businessScope">
						<el-input v-model="dataForm.businessScope" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false" rows="6"
								  maxlength="500" show-word-limit type="textarea" placeholder="经营范围"
								  style="border: none;width: 91%;"></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :lg="12">
					<el-form-item label="企业简介" prop="intro">
						<el-input v-model="dataForm.intro" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false" rows="6"
							maxlength="500" show-word-limit type="textarea" placeholder="企业简介"
							style="border: none;width: 91%;"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :sm="12" :lg="6">
					<el-form-item label="企业名称" prop="caName">
            
						<el-input style="width: 80%;" :disabled="(isPayChannel == 'OPERATE' && dataForm.status == 0) ? false : (isPayChannel == 'OPERATE' && dataForm.status == 2 && !this.isEditBtn) ? false : (isPayChannel != 'OPERATE' && dataForm.status == 0) ? false : true"
							v-model="dataForm.caName" placeholder="企业名称"></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :lg="6">
					<el-form-item label="社会信用代码" prop="taxCode">
						<el-input style="width: 80%;" :disabled="(isPayChannel == 'OPERATE' && dataForm.status == 0) ? false : (isPayChannel == 'OPERATE' && dataForm.status == 2 && !this.isEditBtn) ? false : (isPayChannel != 'OPERATE' && dataForm.status == 0) ? false : true"
							v-model="dataForm.taxCode" placeholder="社会信用代码"></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :lg="6">
					<el-form-item label="开户行" prop="bankName">
						<el-input style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false"
							v-model="dataForm.bankName" placeholder="开户行"></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :lg="6">
					<el-form-item label="银行账户" prop="bankAccount">
						<el-input style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false"
							v-model="dataForm.bankAccount" placeholder="银行账户"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :sm="12" :lg="6">
					<el-form-item label="银行行号信息" prop="bankCode">
						<el-input style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false"
							v-model="dataForm.bankCode" placeholder="银行行号信息"></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :lg="6">
					<el-form-item label="注册地址" prop="address">
						<el-input style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false"
							v-model="dataForm.address" placeholder="注册地址"></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :lg="6">
					<el-form-item label="注册电话" prop="phone">
						<el-input style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false"
							v-model="dataForm.phone" placeholder="注册电话"></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :lg="6">
					<el-form-item label="法人姓名" prop="legalPersonName">
						<el-input style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false"
							v-model="dataForm.legalPersonName" placeholder="法人姓名"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>

				<el-col :sm="12" :lg="6">
					<el-form-item label="法人身份证号" prop="legalPersonIdcard">
						<el-input style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false"
							v-model="dataForm.legalPersonIdcard" placeholder="法人身份证号"></el-input>
					</el-form-item>
				</el-col>
				<el-col :sm="12" :lg="6">
					<el-form-item label="法人手机号" prop="legalPersonPhone">
						<el-input style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false"
							v-model="dataForm.legalPersonPhone" placeholder="法人手机号"></el-input>
					</el-form-item>
				</el-col>
      

        <!-- 新增字段 -->
        <el-col :sm="12" :lg="6">
					<el-form-item label="成立时间" prop="esstablishmentTime">
            <el-date-picker type="date" placeholder="选择日期" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false" v-model="dataForm.esstablishmentTime" style="width: 100%;" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
					</el-form-item>
				</el-col>
        <el-col :sm="12" :lg="6">
					<el-form-item label="经营状况" prop="operatingConditions">
						<el-input style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false" maxlength="500"
							v-model="dataForm.operatingConditions" placeholder="经营状况"></el-input>
					</el-form-item>
				</el-col>
			</el-row>

      <el-row>
        <el-col :sm="12" :lg="6">
					<el-form-item label="所属行业" prop="industry">
						<el-input style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false"
							v-model="dataForm.industry" placeholder="所属行业"></el-input>
					</el-form-item>
				</el-col>
        <el-col :sm="12" :lg="6">
					<el-form-item label="开票地址" prop="taxAddress">
						<el-input style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false" maxlength="200"
							v-model="dataForm.taxAddress" placeholder="开票地址"></el-input>
					</el-form-item>
				</el-col>
        <el-col :sm="12" :lg="6">
					<el-form-item label="是否属于禁入或敏感行业" prop="isSensitive" label-width="200px">
						<!-- <el-input style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false"
							v-model="dataForm.isSensitive" placeholder="是否属于禁入或敏感行业"></el-input> -->
              <el-checkbox v-model="dataForm.isSensitive" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false"></el-checkbox>
					</el-form-item>
				</el-col>
        <!-- <el-col :sm="12" :lg="6" v-if="isPayChannel == 'OPERATE'">
					<el-form-item label="支付渠道" prop="payChannel">
              <el-select v-model="dataForm.payChannel" clearable placeholder="请选择" :disabled="dataForm.status > 0" style="width:80%">
                <el-option
                  v-for="item in payChannel"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
					</el-form-item>
				</el-col> -->
      </el-row>

      <el-row>
        <el-col :sm="12" :lg="12">
					<el-form-item label="用工场景描述" prop="employmentScenario">
						<el-input type="textarea" style="width: 80%;" :disabled="(dataForm.status > 0 && dataForm.status != 2) || (dataForm.status == 2 && this.isEditBtn )?true:false" maxlength="1000"
							v-model="dataForm.employmentScenario" placeholder="用工场景描述"></el-input>
					</el-form-item>
				</el-col>
        <el-col :sm="12" :lg="12" v-if="dataForm.status >= 1 && isPayChannel == 'OPERATE'">
					<el-form-item label="代理商" prop="agentId">
						<el-select v-model="dataForm.agentId" placeholder="请选择" :disabled="(dataForm.status > 1 && this.isEditBtn) ? true:false" style="width:80%" clearable>
                <el-option
                  v-for="item in dlsList"
                  :key="item.id"
                  :label="item.caName"
                  :value="item.id">
                </el-option>
              </el-select>
					</el-form-item>
				</el-col>
      </el-row>
		</el-form>

		<div v-if="dataForm.processList.length > 0">
			<h4 style="margin-left: 30px;font-weight: bold;padding-top:20px;">用户信息状态</h4>
			<p v-for="item in dataForm.processList" style="margin: 0;line-height: 36px;"><span
					style="width: 8px;height: 8px;border-radius: 4px;background-color: #5389DF;display: inline-block;margin-left: 30px;margin-right: 10px;">
				</span>{{item.createDate}}&nbsp;&nbsp;&nbsp;{{item.username}}&nbsp;&nbsp;&nbsp;{{item.action}}</p>
		</div>
	</el-card>
</template>

<script>
import debounce from 'lodash/debounce'
import ossUploadImg from '../oss/oss-upload-img'
import Cookies from 'js-cookie'

export default {
  components: {
    ossUploadImg
  },
  data () {
    return {
      dlsList:[],//代理商列表
      isEditBtn:true,//已审核增加修改功能
      isPayChannel:`${Cookies.get('admin_role')}`,
      payChannel:[
        // {value:0,label:'招商银行'},
        {value:1,label:'支付宝'},
        // {value:2,label:'平安银行'}
      ],
      multiple: false,
      url: `${window.SITE_CONFIG['apiURL']}/oss/file/upload2?access_token=${Cookies.get('access_token')}`,
      tip: '企业营业执照照片',
      tip1: '身份证正面照',
      tip2: '身份证反面照',
      visible: true,
      dialogImageUrl:'',
      dialogVisible:false,
      dataForm: {
        agentId:'',
        payChannel:'',
        intro: '',
        businessScope: '',
        userId: '',
        caName: '',
        taxCode: '',
        bankName: '',
        bankCode: '',
        bankAccount: '',
        address: '',
        contacts: '',
        phone: '',
        legalPersonIdcard: '',
        legalPersonName: '',
        legalPersonPhone: '',
        licensePath: '',
        idcardFacePath: '',
        idcardBackPath: '',
        isEnable: 1,
        status: '',
        userStatus: 0,
        processList: [],
        esstablishmentTime:'',
        operatingConditions:'',
        industry:'',
        employmentScenario:'',
        isSensitive:false,
        taxAddress:''
      }
    }
  },
  computed: {
    dataRule () {
        var validateName = (rule, value, callback) => {
            if(!value){
                callback('必填项不能为空')
            }
            //  else if(value.indexOf('（') > -1 || value.indexOf('）') > -1 ){
            //     callback(new Error("检测出符号错误'（'与'）'必须是英文符号格式！"))
            // }
            callback()
        }
      var checkNumtwo = (rule, value, callback) => {
        if (/^[A-Za-z0-9]{7,20}$/.test(value)) {
          callback()
        } else {
          callback(new Error('社会信用代码格式错误'))
        }
      }
      var checknum = (rule, value, callback) => {
        if (!isNumber(value)) {
          callback(new Error('请输入数字值'))
        }
        callback()
      }
      var checkfloat = (rule, value, callback) => {
        if (/^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/.test(value)) {
          callback()
        } else {
          callback(new Error('请输入数字值,并且最多两位小数'))
        }
      }
      var checkphone = (rule, value, callback) => {
        if (/^1\d{10}$/.test(value)) {
          callback()
        } else if (/^0\d{2,3}-?\d{7,8}$/.test(value)) {
          callback()
        } else {
          callback(new Error('请输入手机号'))
        }
      }
      var checkcard = (rule, value, callback) => {
        if (/^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/
          .test(value)) {
          callback()
        } else {
          callback(new Error('请输入身份证号'))
        }
      }
      var checkbank = (rule, value, callback) => {
        if(/^\d{1,30}$/.test(value) ){
        // if (/^([A-Za-z0-9]{9}|[A-Za-z0-9]{12}|[A-Za-z0-9]{16}|[A-Za-z0-9]{17}|[A-Za-z0-9]{15}|[A-Za-z0-9]{19})$/.test(value)) {
          // if(/^([1-9]{1})(\d{14}|\d{18})$/.test(value)){
          callback()
        } else {
          callback(new Error('请输入卡号'))
        }
      }
      var checkbankCode = (rule, value, callback) => {
        if(value == ''){
          callback(new Error('请输入银行行号信息'))
        }else if(/[^\d]/.test(value)) {
          callback(new Error('只能输入数字'))
        } else {
          callback()
        }
      }
      var validateEmail = (rule, value, callback) => {
        if (!isEmail(value)) {
          return callback(new Error(this.$t('validate.format', {
            'attr': this.$t('user.email')
          })))
        }
        callback()
      }
      return {
        legalPersonIdcard: [{
          required: true,
          message: '请输入身份证号',
          validator: checkcard,
          trigger: 'blur'
        }],
        legalPersonName: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        legalPersonPhone: [{
          required: true,
          message: '输入正确的电话号码',
          validator: checkphone,
          trigger: 'blur'
        }],
        intro: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        businessScope: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        caName: [{
          required: true,
			validator:validateName,
          trigger: 'blur'
        }],
        taxCode: [{
          required: true,
          message: '格式错误，7-20位数字或字母',
          validator: checkNumtwo,
          trigger: 'blur'
        }],
        bankName: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        bankCode: [{
          required: true,
          trigger: 'blur',
          validator:checkbankCode
        }],
        bankAccount: [{
          required: true,
          message: '请输入卡号',
          trigger: 'blur'
        },{ message: '银行卡号错误，请检查位数'
        ,validator: checkbank,
        trigger: 'blur'}],
        address: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        contacts: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '输入正确的电话号码',
          validator: checkphone,
          trigger: 'blur'
        }],
        licensePath: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        esstablishmentTime: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        operatingConditions: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        industry: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        employmentScenario: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
        taxAddress: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'blur'
        }],
      }
    }
  },
  created () {
    this.dataForm.userId = this.$route.params.id || ''
    this.dataForm.status = this.$route.params.status || '0'
    this.getInfo()
  },
  methods: {
    // 已审核增加修改保存功能
    editHandle(){
      if(this.isEditBtn){//修改编辑功能
        this.isEditBtn = false;
      }else{//保存功能
        this.dataFormSubmitHandle(1);
      }
    },
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file;
        this.dialogVisible = true;
      },
    // 上传之前
    beforeUploadHandle (file) {
      if (file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !==
					'image/gif') {
        this.$message.error(this.$t('upload.tip', {
          'format': 'jpg、png、gif'
        }))
        return false
      }
      if (file.size / 1024 / 1024 > 30) {
        this.$message.error('文件太大，只能上传30MB以内的文件')
        return false
      }
    },
    // 上传成功
    beforesuccessHandle (data, file) {
		this.dataForm.idcardFacePath = data.data.url;
        let imgUrl = data.data.url;
        this.$http.post('/sys/plat/info/ca/idcardOCR',{imageUrl:imgUrl}).then(({ data: res })=>{
            if(res.code == 0)
				this.dataForm.legalPersonName = res.data.name;
				this.dataForm.legalPersonIdcard = res.data.idNum;
        })
    },
    backsuccessHandle (data, file) {
      this.dataForm.idcardBackPath = data.data.url
    },
    licensePathsuccessHandle (data, file) {
      this.dataForm.licensePath = data.data.url;
        let imgUrl = data.data.url;
		  const loading = this.$loading({
			lock: true,
			text: '正在识别营业执照...',
			spinner: 'el-icon-loading',
			background: 'rgba(0, 0, 0, 0.7)'
		  })
        this.$http.post('/sys/plat/info/ca/bizLicenseOcr',{imageUrl:imgUrl}).then(({ data: res })=>{
			  loading.close()
            if(res.code == 0){
			  let LicenseInfo = res.data,
                    formInfo = this.dataForm;
//                经营范围
                formInfo.businessScope = LicenseInfo.business
//			  企业名称
                formInfo.caName = LicenseInfo.name
//			  社会信用代码
                formInfo.taxCode = LicenseInfo.regNum
//			  注册地址
                formInfo.address = LicenseInfo.address
//			  法人姓名
                formInfo.legalPersonName = LicenseInfo.person
			  this.$message.success('营业执照识别成功')
		  } else {
			  this.$message.error(res.msg || '营业执照识别失败')
		  }
		  }).catch(error => {
			  loading.close()
			  console.error('营业执照识别错误:', error)
			  this.$message.error('营业执照识别失败，请重试')
		  })
    },
    getInfo () {
      // 获取代理商
      this.$http.get(`sys//plat/info/ca/getAgentList`,{}).then((res) => {
        console.log()
        if(res.code != 0){
          this.dlsList = res.data.data
        }
      })
      this.$http.get(`/sys/plat/info/ca/getInfoByUserId?userId=` + this.dataForm.userId).then(({
        data: res
      }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        this.dataForm.isSensitive = this.dataForm.isSensitive == 1 ? true : false;
      }).catch(() => {})

      
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function (inStatus) {
        this.$refs['dataForm'].validate(valid => {
          if (!valid) {
            return false
          }
          this.dataForm.status = inStatus;
          this.dataForm.userStatus = inStatus;
          // this.dataForm.saveOrSubmit = inStatus
          // this.dataForm.isKeyElement = this.dataForm.isKeyElement ? 1 : 0;
          this.dataForm.isSensitive = this.dataForm.isSensitive ? 1 : 0;
          // this.dataForm.isNeedFaceAuth = this.dataForm.isNeedFaceAuth ? 1 : 0;
          // this.dataForm.isRealName = this.dataForm.isRealName ? 1 : 0;
          this.$http[!this.dataForm.userId ? 'post' : 'put']('/sys/plat/info/ca', this.dataForm).then(({ data: res }) => {
            console.log(res)
              if (res.code == 0) {
                this.$message({
                  message: this.$t('prompt.success'),
                  type: 'success',
                  duration: 500,
                  onClose: () => {
                    // this.$router.push({
                    //   name: 'user-user-listjg'
                    // })
                    this.dataForm.userId = this.$route.params.id || ''
                    this.dataForm.userStatus = this.$route.params.status || '0'
                    this.dataForm.status = this.$route.params.status || '0'
                    this.getInfo()
                  }
                })
                this.isEditBtn = true;
              }else{
                this.isEditBtn = false;
                this.$message.error(res.msg)
              }
            })
            .catch(() => {})
        })
      },
      1000, {
        leading: true,
        trailing: false
      }
    ),
    yulan (url) {
      window.open(url, url)
    },
    delPicUrl(key){
      this.dataForm[key] = '';
    },
    dataFormStatusHandle: debounce(function (inStatus, id) {
      let _this = this
      this.$prompt('请输入审核理由', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({
        value
      }) => {
        let pass = inStatus == 1 ? 'pass' : 'return'
        this.$http.post('/sys/plat/info/ca/audit', {
          userId: id,
          result: pass,
          reason: value,
          agentId:this.dataForm.agentId
        }, {
          headers: {
            'content-type': 'application/json;charset=utf-8'
          }
        }).then(({
          data: res
        }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          if(inStatus == 1){
            this.dataFormSubmitHandle(0)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.getInfo()
            }
          })
        }).catch(() => {})
      })
    })
  }
}
</script>
<style lang="scss">
.delUploadPic{
  color: #F56C6C;
  cursor: pointer;
  float: right;
}
/deep/ .el-noicon::before{
  content: "" !important;
}
</style>